/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  ITradePairHelper,
  ITradePairHelperInterface,
} from "../ITradePairHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs_",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds_",
        type: "uint256[][]",
      },
    ],
    name: "detailsOfPositions",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "margin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "volume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "assetAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "entryPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "liquidationPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentBorrowFeeAmount",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentFundingFeeAmount",
            type: "int256",
          },
        ],
        internalType: "struct PositionDetails[][]",
        name: "positionDetails",
        type: "tuple[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ITradePair[]",
        name: "tradePairs_",
        type: "address[]",
      },
    ],
    name: "pricesOf",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct PricePair[]",
        name: "prices",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ITradePairHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ITradePairHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ITradePairHelper__factory extends ContractFactory {
  constructor(...args: ITradePairHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ITradePairHelper> {
    return super.deploy(overrides || {}) as Promise<ITradePairHelper>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ITradePairHelper {
    return super.attach(address) as ITradePairHelper;
  }
  override connect(signer: Signer): ITradePairHelper__factory {
    return super.connect(signer) as ITradePairHelper__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ITradePairHelperInterface {
    return new utils.Interface(_abi) as ITradePairHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITradePairHelper {
    return new Contract(address, _abi, signerOrProvider) as ITradePairHelper;
  }
}
